var map = {
	"./skin1/btn_right@3x.png": "9afb",
	"./skin2/btn_right@3x.png": "3279",
	"./skin3/btn_right@3x.png": "b733",
	"./skin4/btn_right@3x.png": "32d3",
	"./skin5/btn_right@3x.png": "ba13",
	"./skin6/btn_right@3x.png": "4cbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9751";